import { NgModule } from '@angular/core';
// import { SignInWithApple } from '@awesome-cordova-plugins/sign-in-with-apple/ngx';
// import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
// import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    //GooglePlus, Facebook, 
    //SignInWithApple
  ],
})
export class BoxxOAuthModule {}
